/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestlinkedin1Inputs */

const en_requestlinkedin1 = /** @type {(inputs: Requestlinkedin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LinkedIn`)
};

const de_requestlinkedin1 = /** @type {(inputs: Requestlinkedin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LinkedIn`)
};

/**
* | output |
* | --- |
* | "LinkedIn" |
*
* @param {Requestlinkedin1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestlinkedin1 = /** @type {((inputs?: Requestlinkedin1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestlinkedin1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestlinkedin1(inputs)
	return de_requestlinkedin1(inputs)
});
export { requestlinkedin1 as "requestLinkedin" }